import {AreaFragmentDto, FaceDto, SectionFragmentDto, SectionFragmentType} from "@hec/api-dtos";

export const GetSectionFragmentsByTypeFromFace = (face: FaceDto, sft: SectionFragmentType): SectionFragmentDto[] => {
  const result = face?.sectionFragments.filter(x=> x.sectionFragmentType === sft) ?? [];
  return result;
}
